import DefaultActionManager from "../action_managers/default_action_manager";

export const FETCH_SHOW_CAMPAIGNS_ACTION = "FETCH_SHOW_CAMPAIGNS";
export const FETCH_SHOW_CAMPAIGN_ACTION = "FETCH_SHOW_CAMPAIGN";
export const RESPOND_TO_CAMPAIGN_OFFER_ACTION = "RESPOND_TO_CAMPAIGN_OFFER";

export const getShowCampaigns = showUUID =>
  new DefaultActionManager({
    route: `shows/${showUUID}/campaigns`,
    auth: true,
    actionName: FETCH_SHOW_CAMPAIGNS_ACTION,
    actionData: {
      showUUID,
    },
  }).run();

export const getShowCampaign = (showUUID, campaignUUID) => {
  return new DefaultActionManager({
    route: `shows/${showUUID}/campaigns/${campaignUUID}`,
    auth: true,
    actionName: FETCH_SHOW_CAMPAIGN_ACTION,
    actionData: {
      showUUID,
      campaignUUID,
    },
  }).run();
};

export const respondToCampaignOffer = (campaignItemUUID, state, mediaFileUUID) => {
  let body = { state, ...(mediaFileUUID && { mediaFileUUID }) };
  return new DefaultActionManager({
    route: `campaign-items/${campaignItemUUID}/respond-to-offer`,
    auth: true,
    actionName: RESPOND_TO_CAMPAIGN_OFFER_ACTION,
    actionData: {
      campaignItemUUID,
    },
    body,
    method: "post",
  }).run();
};
